function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "help-chat-2--bubble-help-mark-message-query-question-speech-circle"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.496 1.143a13.357 13.357 0 0 0 -11.117 20.756L1.139 27.854l7.499 -1.357A13.357 13.357 0 1 0 14.498 1.143v0Z",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.414 11.418A3.082 3.082 0 1 1 14.496 14.5v2.055",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group 2575"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.5 21.692a0.514 0.514 0 0 1 0 -1.027",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.5 21.692a0.514 0.514 0 1 0 0 -1.027",
  strokeWidth: 1
})));

function SvgHelpChat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "-0.5 -0.5 30 30",
    height: 30,
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpChat2);
export default __webpack_public_path__ + "static/media/help-chat-2.ad7c19ab.svg";
export { ForwardRef as ReactComponent };